import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';
import { StatusInput } from './statusinput';

let header = new HttpHeaders();
header = header.set('Content-Type', 'application/json; charset=utf-8');


@Injectable({
  providedIn: 'root'
})
export class StatusinputService {


  baseUrl: string = environment.serviceUrl;

  constructor(private httpClient: HttpClient) { }
  Get(): Observable<StatusInput[]> {
    return this.httpClient.get<StatusInput[]>(this.baseUrl + 'api/StatusInputApi/GetAll')
  }
  Post(statusinput: StatusInput): Observable<any> {


    return this.httpClient.post(this.baseUrl + 'api/StatusInputApi/Add', statusinput, { headers: header, observe: 'response' })
  }
  Delete(statusinput: StatusInput) {

    return this.httpClient.post(this.baseUrl + 'api/StatusInputApi/activeordeactive', statusinput, { headers: header, observe: 'response' })
  }
  Put(statusinput: StatusInput): Observable<any> {

    return this.httpClient.put(this.baseUrl + 'api/StatusInputApi/Update', statusinput, { headers: header, observe: 'response' })
  }


}
